import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import axiosConfig from "../../../axiosConfig";

import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";
import CardMedia from "@material-ui/core/CardMedia";
import Swal from "sweetalert2";
import Link from "@material-ui/core/Link";
import Modal from "@material-ui/core/Modal";
import OtpInput from "react-otp-input";
import { makeStyles } from "@material-ui/core/styles";

import * as actions from "../../../store/actions/index";
import { checkValidity } from "../../../shared/validation";
import logo from "../../../assets/images/ehealth.png";
import endPoints from "../../../shared/endPoints.json";

import "./Login.css";

function Login(props) {
  const useStyles = makeStyles((theme) => ({
    paper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#fff",
    },
    avatar: {
      margin: theme.spacing(1),
      backgroundColor: theme.palette.secondary.main,
    },
    form: {
      width: "100%", // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
    cardMedia: {
      paddingTop: "10%",
    },
  }));
  const classes = useStyles();

  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(300);

  useEffect(() => {
    if (otpModalOpen) {
      setTimer(300);
    }
  }, [otpModalOpen]);

  useEffect(() => {
    if (!otpModalOpen) return;

    let interval;
    if (timer > 0) {
        interval = setInterval(() => {
          setTimer((prev) => prev - 1);
        }, 1000);
      } else {
        Swal.fire("Ο χρόνος έληξε", "Παρακαλώ πατήστε 'Aποστολή ξανά' για να λάβετε νέο κωδικό.", "info");
    }
    return () => clearInterval(interval);
  }, [otpModalOpen, timer]);

  useEffect(() => {
    if (otp.length === 6) {
      handleVerifyOtp();
    }
  }, [otp]);
  const inputChangeHandler = (event, controlName) => {
    const updatedControls = {
      ...props.controls,
    };

    const updatedControlElement = {
      ...props.controls[controlName],
    };

    updatedControlElement.value = event.target.value;

    updatedControlElement.valid = checkValidity(
      updatedControlElement.value,
      updatedControlElement.validation
    );

    updatedControlElement.touched = true;

    updatedControls[controlName] = updatedControlElement;

    let formIsValid = true;

    for (let controlName in updatedControls) {
      formIsValid = updatedControls[controlName].valid && formIsValid;
    }

    props.setLoginValidationUIForm({
      controls: updatedControls,
      formIsValid: formIsValid,
    });
  };

  const handleOpen = () => {
    Swal.fire({
      title: "Προσθέστε το email σας",
      input: "email",
      inputAttributes: {
        autocapitalize: "off",
      },
      cancelButtonText: "Άκυρο",
      showCancelButton: true,
      confirmButtonText: "Επιβεβαίωση",
      showLoaderOnConfirm: true,
      preConfirm: (username) => {
        axiosConfig
          .put(
            `/User/SendTemporaryPassword/${username}`
          )
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  };

  const submitHandler = (event) => {
    event.preventDefault();
    const userData = {};
    for (let controlName in props.controls) {
      userData[controlName] = props.controls[controlName].value;
    }
    const mail = userData.email
    const pass = userData.password
    axiosConfig.post("/User/AuthenticateUser", {
      email: mail,
      password: pass
    })
      .then(response => {
        if (response?.data?.requiresOtp) {
          setOtpModalOpen(true);
        }
        else if (response.data?.accessToken && response.status === 200) {
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
        }
        else if (response.message === "Request failed with status code 302") {
          props.setPassword(true);
          props.authorize(false);
          props.history.push({
            pathname: "/set-your-password",
            email: userData.email,
          });
        }
        return response;
      })
      .catch((error) => {
        if (error?.response?.data.requiresOtp) {
          setOtpModalOpen(true);
        } else {
          Swal.fire("Σφάλμα", "Τα στοιχεία σύνδεσης είναι λανθασμένα", "error");
        }
      })
  };

  const handleVerifyOtp = () => {
    const userData = {};
    for (let controlName in props.controls) {
      userData[controlName] = props.controls[controlName].value;
    }
    const mail = userData.email;

    axiosConfig.post("/User/VerifyOtp", {
      email: mail,
      otpCode: otp
    })
      .then(response => {
        if (response.data?.accessToken && response.status === 200) {
          setOtpModalOpen(false);
          localStorage.setItem("user", JSON.stringify(response.data));
          window.location.reload();
        } else {
          setOtp("");
          Swal.fire("Σφάλμα", "Ο κωδικός είναι λανθασμένος ή έχει λήξει.", "error");
        }
        })
      .catch((error) => {
        setOtp("");
        console.log('error', error);
        Swal.fire("Σφάλμα", "Προέκυψε σφάλμα. Παρακαλώ δοκιμάστε ξανά.", "error");
      });
  };

  const handleResendOtp = () => {
    const userData = {};
    for (let controlName in props.controls) {
      userData[controlName] = props.controls[controlName].value;
    }
    const mail = userData.email;
    const pass = userData.password;

    axiosConfig.post("/User/AuthenticateUser", {
      email: mail,
      password: pass
    })
      .then(response => {
        if (response?.data?.requiresOtp) {
          setTimer(300);
          setOtp("");
          Swal.fire("Επιτυχία", "Ο κωδικός εστάλη ξανά.", "success");
        } else if (response.data?.accessToken) {
          window.location.reload();
        }
      })
      .catch((error) => {
        if (error?.response?.data?.requiresOtp) {
          setTimer(300);
          setOtp("");
          Swal.fire("Επιτυχία", "Ο κωδικός εστάλη ξανά.", "success");
        } else {
          Swal.fire("Σφάλμα", "Αποτυχία επαναποστολής κωδικού.", "error");
        }
      });
  };

  function Copyright() {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {"Copyright © "}
        <Link color="inherit" href={endPoints.GUARDIANTELEMATICSLINK}>
          Guardian Telematics
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    );
  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <CardMedia className={classes.cardMedia}>
          <img
            width="50%"
            src={logo}
            alt="ehealth logo"
          />
        </CardMedia>
        <form className={classes.form} onSubmit={submitHandler}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Όνομα Χρήστη"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={(event) => inputChangeHandler(event, "email")}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Κωδικός Χρήστη"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={(event) => inputChangeHandler(event, "password")}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Συνδεση
          </Button>
          <Link onClick={handleOpen} type="submit">
            {"Ξέχασα τον κωδικό πρόσβασης"}
          </Link>
        </form>
      </div>
      <Box mt={5} display="flex" justifyContent="center">
        <Typography variant="body2" color="textSecondary" align="center">
          <Link href="/terms_of_use.pdf" color="inherit" target="_blank" rel="noopener noreferrer">
            Όροι Χρήσης
          </Link>
          {" | "}
          <Link href="/privacy_policy.pdf" color="inherit" target="_blank" rel="noopener noreferrer">
            Πολιτική Απορρήτου
          </Link>
        </Typography>
      </Box>
      <Box mt={2}>
        <Copyright />
      </Box>
      <Modal
        open={otpModalOpen}
        onClose={() => {
          setOtpModalOpen(false);
          setOtp("");
        }}
        className="otpModal"
      >
        <div className="otpModalContainer">
          <Container component="main" maxWidth="xs">
            <div className={`${classes.paper} otpModalPaper`}>
              <Typography variant="h6">Εισαγωγή Προσωρινού Κωδικού</Typography>
              <Typography variant="body2" color="textSecondary" align="center">
                Ένας Προσωρινός Κωδικός έχει σταλεί στο email σας.
              </Typography>
              <Typography variant="body2" color="textSecondary" align="center" className="otpTimerText">
                Χρόνος που απομένει: {Math.floor(timer / 60)}:{timer % 60 < 10 ? '0' : ''}{timer % 60}
              </Typography>
              <div className={classes.form}>
                <Box display="flex" justifyContent="center" mb={2} mt={2}>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    renderSeparator={<span className="otpSeparator"></span>}
                    renderInput={(props) => <input {...props} />}
                    inputStyle="otpInputStyle"
                  />
                </Box>
                <Button
                  onClick={handleResendOtp}
                  fullWidth
                  color="primary"
                  className={`${classes.submit} normalCaseButton`}
                >
                  Αποστολή ξανά
                </Button>
                <Button
                  onClick={() => {
                    setOtpModalOpen(false);
                    setOtp("");
                  }}
                  fullWidth
                  className="normalCaseButton cancelOtpButton"
                >
                  Ακύρωση
                </Button>
              </div>
            </div>
          </Container>
        </div>
      </Modal>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    controls: state.loginValidationUI.controls,
    formIsValid: state.loginValidationUI.formIsValid,
    componentIds: state.auth.componentIds,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    authorize: (isAuthBool) => {
      dispatch(actions.authorizeValidation(isAuthBool));
    },
    setLoginValidationUIForm: (validationPayload) => {
      dispatch(actions.setValidationUILoginForm(validationPayload));
    },
    municipalityMapState: (id) => {
      dispatch(actions.setMunicipalityId(id));
    },
    setIsReloaded: () => {
      dispatch(actions.setIsReloaded());
    },
    setPassword: (isPrimaryBool) => {
      dispatch(actions.setPassword(isPrimaryBool));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
